import React, { useEffect, useState, useMemo } from "react";
import { Translator } from "./translator";

const Privacy = () => {
  const { translateText, lang } = Translator();

  // --------- Fixed IT / EN / FR texts, Translator for others ---------
  const baseTextByLang = useMemo(
    () => ({
      it: {
        textPrivacy: "Informativa sulla Privacy",
        textLastUpdated: "Ultimo Aggiornamento:",
        textdate: "16 gennaio 2025",

        text1:
          "Noi di Te.C.H-e (di proprietà e gestita da Emozionarti Srl) comprendiamo l'importanza di proteggere le tue informazioni personali e ci impegniamo a salvaguardarle. Questa Informativa sulla Privacy spiega come raccogliamo, utilizziamo e condividiamo le tue informazioni quando utilizzi il sito web di Te.C.H-e, i servizi di tour digitali e le piattaforme correlate (collettivamente, i “Servizi Te.C.H-e”). Utilizzando i Servizi Te.C.H-e, accetti le pratiche descritte in questa Informativa sulla Privacy.",
        text2:
          "Per ulteriori informazioni sui tuoi diritti e su come trattiamo i dati personali in conformità con le leggi applicabili, ti preghiamo di contattarci direttamente.",

        text3: "Quali informazioni personali raccogliamo?",
        text4:
          "Per fornire e migliorare i Servizi Te.C.H-e, raccogliamo i seguenti tipi di informazioni personali:",
        text5: "Informazioni fornite dall'utente",
        text6: "Raccogliamo e memorizziamo tutte le informazioni che fornisci quando:",
        text7: "• Registri un account o aggiorni il tuo profilo.",
        text8: "• Acquisti un tour digitale o servizi correlati.",
        text9: "• Contatti il nostro team di assistenza clienti o compili un sondaggio.",
        text10: "• Ti iscrivi alle nostre newsletter o a materiale promozionale.",
        text11: "Queste informazioni possono includere:",
        text12: "• Dati identificativi (es. nome, email, numero di telefono, indirizzo di fatturazione).",
        text13: "• Informazioni di pagamento (es. dettagli della carta di credito/debito).",
        text14: "• Preferenze relative alla tua esperienza di tour.",
        text15: "• Messaggi o feedback condivisi tramite la nostra piattaforma.",

        text16: "Informazioni raccolte automaticamente",
        text17:
          "Raccogliamo e memorizziamo informazioni sulle tue interazioni con i Servizi Te.C.H-e, tra cui:",
        text18:
          "• Dettagli del dispositivo e del browser (es. indirizzo IP, sistema operativo e tipo di browser).",
        text19:
          "• Dati di utilizzo (es. pagine visualizzate, clic e tempo trascorso sulla nostra piattaforma).",
        text20: "• Dati di localizzazione (se abilitati sul tuo dispositivo).",
        text21:
          "Utilizziamo cookie e tecnologie simili per migliorare l’esperienza dell’utente e analizzare le prestazioni del sito web. Per ulteriori informazioni, consulta la nostra ",
        text22: "Informativa sui Cookie",

        text23: "Informazioni da altre fonti",
        text24: "Potremmo ricevere informazioni da terze parti, come ad esempio:",
        text25: "• Processori di pagamento per confermare le transazioni.",
        text26: "• Piattaforme di social media, se scegli di connetterti tramite tali servizi.",
        text27: "• Feedback su problemi tecnici per migliorare la nostra piattaforma.",

        text28: "Come utilizziamo le tue informazioni personali?",
        text29:
          "Utilizziamo le tue informazioni per gestire, migliorare e personalizzare i Servizi Te.C.H-e. Nello specifico, utilizziamo i tuoi dati per:",
        text30:
          "• Fornire i Servizi: elaborare gli ordini, consegnare i tour digitali e gestire il tuo account.",
        text31:
          "• Personalizzazione: raccomandare tour o funzionalità in base alle tue preferenze.",
        text32: "• Assistenza clienti: rispondere alle richieste e risolvere problemi tecnici.",
        text33:
          "• Marketing: inviare offerte, aggiornamenti e materiale promozionale pertinenti (con il tuo consenso).",
        text34:
          "• Conformità: rispettare gli obblighi di legge e proteggere da frodi.",

        text35: "Come vengono condivise le tue informazioni?",
        text36:
          "Valorizziamo la tua privacy e condividiamo le informazioni solo come indicato di seguito:",
        text37: "Fornitori di Servizi",
        text38: "Collaboriamo con fornitori di servizi terzi fidati per:",
        text39: "• Elaborare i pagamenti in modo sicuro.",
        text40: "• Inviare comunicazioni e materiale di marketing.",
        text41: "• Ospitare e mantenere la nostra piattaforma.",
        text42:
          "Questi fornitori sono autorizzati a utilizzare le tue informazioni solo per i servizi che forniscono per nostro conto.",
        text43: "Obblighi legali e protezione",
        text44:
          "Potremmo divulgare le tue informazioni quando richiesto per rispettare le leggi applicabili o per proteggere i diritti, la proprietà o la sicurezza di Te.C.H-e, dei suoi utenti o di altri.",
        text45: "Trasferimenti aziendali",
        text46:
          "In caso di fusione, acquisizione o vendita di beni aziendali, le tue informazioni potrebbero essere trasferite come parte della transazione.",
        text47: "Come proteggiamo le tue informazioni?",
        text48: "Adottiamo misure tecniche, amministrative e fisiche per proteggere i tuoi dati, tra cui:",
        text49: "• Protocolli di crittografia per la trasmissione dei dati.",
        text50: "• Pratiche di archiviazione sicura.",
        text51: "• Controlli di accesso per garantire che solo il personale autorizzato gestisca dati sensibili.",
        text52:
          "Sei responsabile della riservatezza delle credenziali del tuo account. Ti consigliamo di utilizzare una password unica e sicura.",

        text53: "Le tue scelte e i tuoi diritti",
        text54:
          "Hai il controllo sui tuoi dati personali. Ecco come puoi gestire le tue preferenze:",
        text55:
          "• Accesso e aggiornamento delle informazioni: puoi visualizzare e aggiornare i dettagli del tuo account tramite le impostazioni del profilo.",
        text56:
          "• Preferenze di marketing: puoi disattivare le email promozionali modificando le tue preferenze di comunicazione.",
        text57:
          "• Gestione dei cookie: modifica le impostazioni del browser per bloccare o eliminare i cookie.",
        text58:
          "• Cancellazione dei dati: richiedi la cancellazione dei tuoi dati personali contattando il nostro team di supporto.",
        text59:
          "Per esercitare i tuoi diritti ai sensi delle leggi sulla protezione dei dati, contattaci a",

        text60: "Tutela della privacy dei minori",
        text61:
          "I Servizi Te.C.H-e non sono destinati ai minori di 13 anni e non raccogliamo consapevolmente informazioni personali da essi senza il consenso dei genitori. Se ritieni che siano state raccolte informazioni di un minore, ti preghiamo di contattarci per la rimozione.",

        text62: "Cookie e tecnologie di tracciamento",
        text63: "Te.C.H-e utilizza cookie per:",
        text64: "• Migliorare la funzionalità e le prestazioni del sito.",
        text65: "• Fornire raccomandazioni personalizzate.",
        text66: "• Analizzare i trend di utilizzo.",
        text67: "Per ulteriori dettagli su come utilizziamo i cookie, consulta la nostra ",
        text68: "Informativa sui Cookie.",

        text69: "Aggiornamenti a questa Informativa sulla Privacy",
        text70:
          "Potremmo aggiornare periodicamente questa Informativa per riflettere modifiche alle nostre pratiche o per motivi legali. Eventuali modifiche significative saranno comunicate tramite il nostro sito web o via email. La data “Ultimo aggiornamento” indica la revisione più recente.",

        text71: "Contattaci",
        text72:
          "Per domande o dubbi su questa Informativa o sui tuoi dati, contattaci a:",
        text73: "Emozionarti Srl",
        text74: "Via Giuseppe Verdi, 46",
        text75: "Pomigliano d'Arco – 80038 (NA), Italia",
        text76: "Telefono fisso: +39 081 424 4274",
        text77: "xxx",
        text78: "xxx",
        text79: "xxx",
        text80: "xxx",

        text81: "Cancellazione dei dati / Eliminazione account",
        text82:
          "Se desideri eliminare il tuo account Te.C.H-e e cancellare i dati personali associati, segui una delle opzioni qui sotto.",
        text83: "Richiesta via email",
        text84:
          "invia un’email da quell’indirizzo a",
        text84Alt: "(oppure a",
        text85:
          'con oggetto: “Eliminazione account Te.C.H-e”. Nel testo indica nome e indirizzo email registrato.',
        text86: "Verifica",
        text87:
          "per proteggere il tuo account, potremmo chiederti una breve conferma di identità (es. verifica del link ricevuto via email).",
        text88: "Tempi",
        text89:
          "disattiviamo l’accesso entro 72 ore dalla conferma e completiamo la cancellazione dei dati personali entro 30 giorni, salvo obblighi di conservazione legale (es. dati fiscali).",
        text90: "Cosa viene eliminato:",
        text91:
          "dati del profilo, preferenze, contenuti generati dall’utente e cronologia delle interazioni.",
        text92: "Cosa può restare:",
        text93:
          "informazioni che dobbiamo mantenere per legge (ad es. documenti fiscali e contabili) per il periodo richiesto dalla normativa.",
        text94:
          "Se hai domande sulla cancellazione dei dati o sullo stato della richiesta, contattaci a",
      },

      en: {
        textPrivacy: "Privacy Policy",
        textLastUpdated: "Last Updated:",
        textdate: "16 January 2025",

        text1:
          "At Te.C.H-e (owned and operated by Emozionarti Srl), we understand the importance of protecting your personal information and are committed to safeguarding it. This Privacy Policy explains how we collect, use, and share your information when you use the Te.C.H-e website, digital tour services, and related platforms (collectively, the “Te.C.H-e Services”). By using the Te.C.H-e Services, you agree to the practices described in this Privacy Policy.",
        text2:
          "For more information about your rights and how we process personal data in accordance with applicable laws, please contact us directly.",

        text3: "What personal information do we collect?",
        text4:
          "To provide and improve the Te.C.H-e Services, we collect the following types of personal information:",
        text5: "Information you provide",
        text6: "We collect and store any information you provide when you:",
        text7: "• Register an account or update your profile.",
        text8: "• Purchase a digital tour or related services.",
        text9: "• Contact our customer support team or complete a survey.",
        text10: "• Subscribe to our newsletters or promotional material.",
        text11: "This information may include:",
        text12:
          "• Identification data (e.g. name, email address, phone number, billing address).",
        text13: "• Payment information (e.g. credit/debit card details).",
        text14: "• Preferences related to your tour experience.",
        text15: "• Messages or feedback shared through our platform.",

        text16: "Information collected automatically",
        text17:
          "We collect and store information about your interactions with the Te.C.H-e Services, including:",
        text18:
          "• Device and browser details (e.g. IP address, operating system, browser type).",
        text19:
          "• Usage data (e.g. pages viewed, clicks, and time spent on our platform).",
        text20: "• Location data (if enabled on your device).",
        text21:
          "We use cookies and similar technologies to improve the user experience and analyze website performance. For more information, please see our ",
        text22: "Cookie Policy",

        text23: "Information from other sources",
        text24: "We may receive information from third parties, such as:",
        text25: "• Payment processors, to confirm transactions.",
        text26:
          "• Social media platforms, if you choose to connect through those services.",
        text27:
          "• Feedback on technical issues, to help improve our platform.",

        text28: "How do we use your personal information?",
        text29:
          "We use your information to operate, improve, and personalize the Te.C.H-e Services. In particular, we use your data to:",
        text30:
          "• Provide Services: process orders, deliver digital tours, and manage your account.",
        text31:
          "• Personalization: recommend tours or features based on your preferences.",
        text32:
          "• Customer support: respond to requests and resolve technical issues.",
        text33:
          "• Marketing: send relevant offers, updates, and promotional material (with your consent).",
        text34:
          "• Compliance: comply with legal obligations and protect against fraud.",

        text35: "How is your information shared?",
        text36:
          "We value your privacy and share information only as described below:",
        text37: "Service Providers",
        text38: "We work with trusted third-party service providers to:",
        text39: "• Securely process payments.",
        text40: "• Send communications and marketing material.",
        text41: "• Host and maintain our platform.",
        text42:
          "These providers are authorized to use your information only to perform services on our behalf.",
        text43: "Legal obligations and protection",
        text44:
          "We may disclose your information when required to comply with applicable laws or to protect the rights, property, or safety of Te.C.H-e, its users, or others.",
        text45: "Business transfers",
        text46:
          "In the event of a merger, acquisition, or sale of business assets, your information may be transferred as part of the transaction.",
        text47: "How do we protect your information?",
        text48:
          "We implement technical, administrative, and physical measures to protect your data, including:",
        text49: "• Encryption protocols for data transmission.",
        text50: "• Secure storage practices.",
        text51:
          "• Access controls to ensure that only authorized personnel handle sensitive data.",
        text52:
          "You are responsible for keeping your account credentials confidential. We recommend using a strong, unique password.",

        text53: "Your choices and your rights",
        text54:
          "You have control over your personal data. Here is how you can manage your preferences:",
        text55:
          "• Access and update information: you can view and update your account details via your profile settings.",
        text56:
          "• Marketing preferences: you can opt out of promotional emails by changing your communication preferences.",
        text57:
          "• Cookie management: adjust your browser settings to block or delete cookies.",
        text58:
          "• Data deletion: request deletion of your personal data by contacting our support team.",
        text59:
          "To exercise your rights under data protection laws, contact us at",

        text60: "Children’s privacy",
        text61:
          "The Te.C.H-e Services are not intended for children under 13, and we do not knowingly collect personal information from them without parental consent. If you believe a child’s information has been collected, please contact us so we can remove it.",

        text62: "Cookies and tracking technologies",
        text63: "Te.C.H-e uses cookies to:",
        text64: "• Improve site functionality and performance.",
        text65: "• Provide personalized recommendations.",
        text66: "• Analyze usage trends.",
        text67: "For more details on how we use cookies, please see our ",
        text68: "Cookie Policy.",

        text69: "Updates to this Privacy Policy",
        text70:
          "We may periodically update this Policy to reflect changes in our practices or for legal reasons. Any significant changes will be communicated via our website or by email. The “Last Updated” date indicates the most recent revision.",

        text71: "Contact Us",
        text72:
          "If you have any questions or concerns about this Policy or your data, please contact us at:",
        text73: "Emozionarti Srl",
        text74: "Via Giuseppe Verdi, 46",
        text75: "Pomigliano d'Arco – 80038 (NA), Italy",
        text76: "Landline phone: +39 081 424 4274",
        text77: "xxx",
        text78: "xxx",
        text79: "xxx",
        text80: "xxx",

        text81: "Data deletion / Account removal",
        text82:
          "If you wish to delete your Te.C.H-e account and erase associated personal data, follow one of the options below.",
        text83: "Request by email",
        text84: "send an email from that address to",
        text84Alt: "(or to",
        text85:
          'with subject: “Delete Te.C.H-e account”. In the body, include your name and registered email address.',
        text86: "Verification",
        text87:
          "to protect your account, we may ask for a brief identity confirmation (e.g. validating a link received via email).",
        text88: "Timing",
        text89:
          "we disable access within 72 hours of confirmation and complete deletion of personal data within 30 days, except where we must retain data for legal reasons (e.g. tax records).",
        text90: "What is deleted:",
        text91:
          "profile data, preferences, user-generated content, and interaction history.",
        text92: "What may remain:",
        text93:
          "information we must keep by law (e.g. tax and accounting documents) for the period required by regulation.",
        text94:
          "If you have questions about data deletion or the status of your request, contact us at",
      },

      fr: {
        textPrivacy: "Politique de Confidentialité",
        textLastUpdated: "Dernière mise à jour :",
        textdate: "16 janvier 2025",

        text1:
          "Chez Te.C.H-e (propriété et géré par Emozionarti Srl), nous comprenons l’importance de protéger vos informations personnelles et nous nous engageons à les préserver. La présente Politique de Confidentialité explique comment nous collectons, utilisons et partageons vos informations lorsque vous utilisez le site web Te.C.H-e, les services de visites numériques et les plateformes associées (collectivement, les « Services Te.C.H-e »). En utilisant les Services Te.C.H-e, vous acceptez les pratiques décrites dans cette Politique de Confidentialité.",
        text2:
          "Pour plus d’informations sur vos droits et sur la manière dont nous traitons les données personnelles conformément aux lois applicables, veuillez nous contacter directement.",

        text3: "Quelles informations personnelles collectons-nous ?",
        text4:
          "Pour fournir et améliorer les Services Te.C.H-e, nous collectons les types d’informations personnelles suivants :",
        text5: "Informations fournies par l’utilisateur",
        text6:
          "Nous collectons et stockons toutes les informations que vous fournissez lorsque vous :",
        text7:
          "• Créez un compte ou mettez à jour votre profil.",
        text8:
          "• Achetez une visite numérique ou des services associés.",
        text9:
          "• Contactez notre service clientèle ou remplissez un sondage.",
        text10:
          "• Vous abonnez à nos newsletters ou à du matériel promotionnel.",
        text11: "Ces informations peuvent inclure :",
        text12:
          "• Données d’identification (par ex. nom, adresse email, numéro de téléphone, adresse de facturation).",
        text13:
          "• Informations de paiement (par ex. coordonnées de carte de crédit/débit).",
        text14:
          "• Préférences liées à votre expérience de visite.",
        text15:
          "• Messages ou commentaires partagés via notre plateforme.",

        text16: "Informations collectées automatiquement",
        text17:
          "Nous collectons et stockons des informations sur vos interactions avec les Services Te.C.H-e, notamment :",
        text18:
          "• Détails de l’appareil et du navigateur (par ex. adresse IP, système d’exploitation, type de navigateur).",
        text19:
          "• Données d’utilisation (par ex. pages consultées, clics et temps passé sur notre plateforme).",
        text20:
          "• Données de localisation (si activées sur votre appareil).",
        text21:
          "Nous utilisons des cookies et des technologies similaires pour améliorer l’expérience utilisateur et analyser les performances du site. Pour en savoir plus, consultez notre ",
        text22: "Politique relative aux Cookies",

        text23: "Informations provenant d’autres sources",
        text24:
          "Nous pouvons recevoir des informations de la part de tiers, tels que :",
        text25:
          "• Prestataires de paiement, pour confirmer les transactions.",
        text26:
          "• Plateformes de réseaux sociaux, si vous choisissez de vous connecter via ces services.",
        text27:
          "• Retours sur des problèmes techniques, afin d’améliorer notre plateforme.",

        text28: "Comment utilisons-nous vos informations personnelles ?",
        text29:
          "Nous utilisons vos informations pour gérer, améliorer et personnaliser les Services Te.C.H-e. En particulier, nous utilisons vos données pour :",
        text30:
          "• Fournir les Services : traiter les commandes, délivrer les visites numériques et gérer votre compte.",
        text31:
          "• Personnalisation : recommander des visites ou des fonctionnalités en fonction de vos préférences.",
        text32:
          "• Service client : répondre à vos demandes et résoudre les problèmes techniques.",
        text33:
          "• Marketing : envoyer des offres, des mises à jour et du contenu promotionnel pertinent (avec votre consentement).",
        text34:
          "• Conformité : respecter les obligations légales et se protéger contre la fraude.",

        text35: "Comment vos informations sont-elles partagées ?",
        text36:
          "Nous attachons une grande importance à votre vie privée et ne partageons vos informations que comme indiqué ci-dessous :",
        text37: "Prestataires de services",
        text38:
          "Nous collaborons avec des prestataires de services tiers de confiance pour :",
        text39:
          "• Traiter les paiements de manière sécurisée.",
        text40:
          "• Envoyer des communications et du matériel marketing.",
        text41:
          "• Héberger et maintenir notre plateforme.",
        text42:
          "Ces prestataires sont autorisés à utiliser vos informations uniquement pour fournir des services en notre nom.",
        text43: "Obligations légales et protection",
        text44:
          "Nous pouvons divulguer vos informations lorsque cela est nécessaire pour respecter les lois applicables ou pour protéger les droits, la propriété ou la sécurité de Te.C.H-e, de ses utilisateurs ou de tiers.",
        text45: "Transferts d’entreprise",
        text46:
          "En cas de fusion, d’acquisition ou de cession d’actifs, vos informations peuvent être transférées dans le cadre de l’opération.",
        text47: "Comment protégeons-nous vos informations ?",
        text48:
          "Nous mettons en œuvre des mesures techniques, administratives et physiques pour protéger vos données, notamment :",
        text49:
          "• Protocoles de chiffrement pour la transmission des données.",
        text50: "• Pratiques de stockage sécurisé.",
        text51:
          "• Contrôles d’accès pour garantir que seules les personnes autorisées traitent des données sensibles.",
        text52:
          "Vous êtes responsable de la confidentialité de vos identifiants de compte. Nous vous recommandons d’utiliser un mot de passe unique et sécurisé.",

        text53: "Vos choix et vos droits",
        text54:
          "Vous gardez le contrôle sur vos données personnelles. Voici comment gérer vos préférences :",
        text55:
          "• Accès et mise à jour des informations : vous pouvez consulter et mettre à jour les informations de votre compte dans les paramètres de profil.",
        text56:
          "• Préférences marketing : vous pouvez vous désabonner des emails promotionnels en modifiant vos préférences de communication.",
        text57:
          "• Gestion des cookies : modifiez les paramètres de votre navigateur pour bloquer ou supprimer les cookies.",
        text58:
          "• Suppression des données : demandez la suppression de vos données personnelles en contactant notre service d’assistance.",
        text59:
          "Pour exercer vos droits en matière de protection des données, contactez-nous à l’adresse",

        text60: "Protection de la vie privée des mineurs",
        text61:
          "Les Services Te.C.H-e ne sont pas destinés aux enfants de moins de 13 ans et nous ne collectons pas sciemment d’informations personnelles les concernant sans le consentement des parents. Si vous pensez que des informations concernant un mineur ont été collectées, veuillez nous contacter afin que nous puissions les supprimer.",

        text62: "Cookies et technologies de suivi",
        text63: "Te.C.H-e utilise des cookies pour :",
        text64:
          "• Améliorer les fonctionnalités et les performances du site.",
        text65:
          "• Fournir des recommandations personnalisées.",
        text66:
          "• Analyser les tendances d’utilisation.",
        text67:
          "Pour plus de détails sur notre utilisation des cookies, consultez notre ",
        text68: "Politique relative aux Cookies.",

        text69: "Mises à jour de cette Politique de Confidentialité",
        text70:
          "Nous pouvons mettre périodiquement cette Politique à jour pour refléter des changements dans nos pratiques ou pour des raisons légales. Toute modification importante sera communiquée via notre site web ou par email. La date de « Dernière mise à jour » indique la révision la plus récente.",

        text71: "Contactez-nous",
        text72:
          "Pour toute question ou préoccupation concernant cette Politique ou vos données, contactez-nous à :",
        text73: "Emozionarti Srl",
        text74: "Via Giuseppe Verdi, 46",
        text75: "Pomigliano d'Arco – 80038 (NA), Italie",
        text76: "Téléphone fixe : +39 081 424 4274",
        text77: "xxx",
        text78: "xxx",
        text79: "xxx",
        text80: "xxx",

        text81: "Suppression des données / Suppression de compte",
        text82:
          "Si vous souhaitez supprimer votre compte Te.C.H-e et effacer les données personnelles associées, suivez l’une des options ci-dessous.",
        text83: "Demande par email",
        text84:
          "envoyez un email depuis cette adresse à",
        text84Alt: "(ou à",
        text85:
          'avec pour objet : « Suppression du compte Te.C.H-e ». Dans le message, indiquez votre nom et l’adresse email enregistrée.',
        text86: "Vérification",
        text87:
          "pour protéger votre compte, nous pouvons vous demander une brève confirmation d’identité (par ex. validation d’un lien reçu par email).",
        text88: "Délais",
        text89:
          "nous désactivons l’accès dans les 72 heures suivant la confirmation et achevons la suppression des données personnelles dans les 30 jours, sauf obligation légale de conservation (par ex. données fiscales).",
        text90: "Ce qui est supprimé :",
        text91:
          "données de profil, préférences, contenus générés par l’utilisateur et historique des interactions.",
        text92: "Ce qui peut être conservé :",
        text93:
          "les informations que nous devons conserver pour des raisons légales (par ex. documents fiscaux et comptables) pendant la durée requise par la réglementation.",
        text94:
          "Pour toute question concernant la suppression des données ou le statut de votre demande, contactez-nous à",
      },
    }),
    []
  );

  const [t, setT] = useState(baseTextByLang[lang] || baseTextByLang.en);

  useEffect(() => {
    // Fixed IT / EN / FR
    if (lang === "it" || lang === "en" || lang === "fr") {
      setT(baseTextByLang[lang] || baseTextByLang.en);
      return;
    }

    // Other languages → translate from Italian version
    let cancelled = false;
    (async () => {
      try {
        const source = baseTextByLang.it;
        const entries = Object.entries(source);
        const translated = await Promise.all(
          entries.map(async ([key, value]) => {
            const out = await translateText(value);
            return [key, out || value];
          })
        );
        if (!cancelled) {
          setT(Object.fromEntries(translated));
        }
      } catch {
        if (!cancelled) {
          setT(baseTextByLang.en);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [lang, translateText, baseTextByLang]);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1 className="mb-4 text-center">{t.textPrivacy}</h1>
      <p className="mb-4 text-center">
        <strong>{t.textLastUpdated} </strong>
        {t.textdate}
      </p>
      <hr />
      <p className="mb-4 text-center">{t.text1}</p>
      <p className="mb-4 text-center">{t.text2}</p>
      <hr />

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text3}
      </h2>
      <p className="mb-4 text-center">{t.text4}</p>

      <h3 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text5}
      </h3>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text6} <br />
        {t.text7} <br />
        {t.text8} <br />
        {t.text9} <br />
        {t.text10} <br />
      </div>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text11}
        <br />
        {t.text12} <br />
        {t.text13} <br />
        {t.text14} <br />
        {t.text15} <br />
      </div>

      <h2 className="text-[1.2rem] text-black mt-5 mb-2 text-center">
        {t.text16}
      </h2>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text17} <br />
        {t.text18} <br />
        {t.text19} <br />
        {t.text20} <br /> <br />
        {t.text21}
        <a
          className="text-blue-600 no-underline hover:no-underline"
          href="/cookies"
        >
          {t.text22}
        </a>
      </div>

      <h2 className="text-[1.2rem] text-black mt-5 mb-2 text-center">
        {t.text23}
      </h2>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text24} <br />
        {t.text25} <br />
        {t.text26} <br />
        {t.text27} <br />
      </div>
      <hr />

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text28}
      </h2>
      <p className="mb-4 text-center">{t.text29}</p>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text30} <br />
        {t.text31} <br />
        {t.text32} <br />
        {t.text33} <br />
        {t.text34} <br />
      </div>

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text35}
      </h2>
      <p className="mb-4 text-center">{t.text36}</p>

      <h2 className="text-[1.2rem] text-black mt-5 mb-2 text-center">
        {t.text37}
      </h2>
      <p className="mb-4 text-center">{t.text38}</p>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text39} <br />
        {t.text40} <br />
        {t.text41} <br />
      </div>
      <p className="mb-4 text-center">{t.text42}</p>

      <h2 className="text-[1.2rem] text-black mt-5 mb-2 text-center">
        {t.text43}
      </h2>
      <p className="mb-4 text-center">{t.text44}</p>

      <h2 className="text-[1.2rem] text-black mt-5 mb-2 text-center">
        {t.text45}
      </h2>
      <p className="mb-4 text-center">{t.text46}</p>

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text47}
      </h2>
      <p className="mb-4 text-center">{t.text48}</p>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text49} <br />
        {t.text50} <br />
        {t.text51} <br />
      </div>
      <p className="mb-4 text-center">{t.text52}</p>

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text53}
      </h2>
      <p className="mb-4 text-center">{t.text54}</p>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text55} <br />
        {t.text56} <br />
        {t.text57} <br />
        {t.text58} <br />
      </div>
      <p className="mb-4 text-center">
        {t.text59}{" "}
        <a href="mailto:emozionartisrl@gmail.com">emozionartisrl@gmail.com</a>
      </p>

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text60}
      </h2>
      <p className="mb-4 text-center">{t.text61}</p>

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text62}
      </h2>
      <div className="text-[1rem] leading-relaxed text-black my-4 mx-auto w-[80%] max-w-[37.5rem] text-center">
        {t.text63} <br />
        {t.text64} <br />
        {t.text65} <br />
        {t.text66} <br />
      </div>
      <p className="mb-4 text-center">
        {t.text67}
        <a
          className="text-blue-600 no-underline hover:no-underline"
          href="/cookies"
        >
          {" "}
          {t.text68}
        </a>
      </p>

      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text69}
      </h2>
      <p className="mb-4 text-center">{t.text70}</p>

      {/* Data deletion section */}
      <h2
        id="data-deletion"
        className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center"
      >
        {t.text81}
      </h2>
      <p className="text-center mb-4">{t.text82}</p>

      <ol className="text-left mx-auto w-[80%] max-w-[37.5rem] list-decimal list-inside leading-relaxed text-black">
        <li>
          <strong>{t.text83}</strong> — {t.text84}{" "}
          <a href="mailto:emozionartisrl@gmail.com">emozionartisrl@gmail.com</a>{" "}
          {t.text84Alt}{" "}
          <a href="mailto:info@emozion-arti.com">info@emozion-arti.com</a>{" "}
          {t.text85}
        </li>
        <li>
          <strong>{t.text86}</strong> — {t.text87}
        </li>
        <li>
          <strong>{t.text88}</strong> — {t.text89}
        </li>
      </ol>

      <p className="text-center mt-4">
        <strong>{t.text90}</strong> {t.text91}{" "}
        <strong>{t.text92}</strong> {t.text93}
      </p>

      {/* Contact section */}
      <h2 className="text-[2.5rem] text-black mt-[20px] mb-[10px] text-center">
        {t.text71}
      </h2>
      <p className="mb-4 text-center">{t.text72}</p>
      <h2 className="text-[1.2rem] text-black mt-5 mb-2 text-center">
        {t.text73}
      </h2>
      <p className="mb-4 text-center">
        {t.text74} <br />
        {t.text75} <br />
        <a href="mailto:emozionartisrl@gmail.com">emozionartisrl@gmail.com</a>
        <br />
        {t.text76}
      </p>
    </div>
  );
};

export default Privacy;
